var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import SubmissionsForProviderApprovalService from "../services/SubmissionsForProviderApprovalService";
import UploadingArtFiles from "./UploadingArtFiles";
import Notification from "../../App/components/Notification";
import "../styles/ModalUploadTicket.css";
import "../styles/Arts.css";
import Modal from 'react-bootstrap/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from "react-router-dom";
import { handleServiceError } from "../../App/components/ErrorHandler";
import { onEnterOrSpace } from "../../App/utils/accessibility";
import { notifyOpenerArtUpdated } from "../../App/utils/windowMessaging";
function ModalUploadTicket(props) {
    var _this = this;
    var _a = useState(""), textAreaValue = _a[0], setTextAreaValue = _a[1];
    var _b = useState(false), isContesting = _b[0], setIsContesting = _b[1];
    var _c = useState(false), isCorrection = _c[0], setIsCorrection = _c[1];
    var _d = useState(null), file = _d[0], setFile = _d[1];
    var _e = useState(""), linkText = _e[0], setLinkText = _e[1];
    var params = useParams();
    var artId = params.art_id;
    function handleChange(event) {
        setTextAreaValue(event.target.value);
    }
    ;
    var handleContestClick = function () {
        setIsContesting(true);
        setIsCorrection(false);
    };
    var handleCorrectionClick = function () {
        setIsContesting(false);
        setIsCorrection(true);
    };
    var handleFormSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!isContesting) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleContestation()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!isCorrection) return [3 /*break*/, 4];
                    return [4 /*yield*/, handleCorrection()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleContestation = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle("[data-id=arts-grid]");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, SubmissionsForProviderApprovalService.contestArt({
                            artId: props.artHistories[0].art_id,
                            contestation: textAreaValue,
                        })];
                case 2:
                    _a.sent();
                    props.closeModalUploadTicket();
                    Notification().Notify.success("Contestação enviada com sucesso!");
                    notifyOpenerArtUpdated();
                    window.location.reload();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    handleServiceError(error_1);
                    return [3 /*break*/, 4];
                case 4:
                    Notification().Block.remove("[data-id=arts-grid]");
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCorrection = function () { return __awaiter(_this, void 0, void 0, function () {
        var formData, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Notification().Block.circle("[data-id=arts-grid]");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    formData = new FormData();
                    formData.append("artId", props.artHistories[0].art_id.toString());
                    formData.append("correction", textAreaValue);
                    if (linkText && linkText.trim() !== "") {
                        formData.append("link", linkText);
                    }
                    if (file) {
                        formData.append("file", file);
                    }
                    return [4 /*yield*/, SubmissionsForProviderApprovalService.sendCorrection(formData)];
                case 2:
                    _a.sent();
                    props.closeModalUploadTicket();
                    Notification().Notify.success("Correção enviada com sucesso!");
                    notifyOpenerArtUpdated();
                    window.location.reload();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    handleServiceError(error_2);
                    return [3 /*break*/, 4];
                case 4:
                    Notification().Block.remove("[data-id=arts-grid]");
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Modal, __assign({ show: props.showModalUploadTicket, onHide: props.closeModalUploadTicket, "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "modal-upload-ticket modal-arts" }, { children: [_jsxs(Modal.Header, { children: [_jsxs("h3", { children: ["Resposta #", artId] }), _jsx(CloseIcon, { id: "btn-modal-upload-ticket-close-icon", role: "button", tabIndex: 0, "aria-label": "Fechar", onClick: props.closeModalUploadTicket, onKeyDown: onEnterOrSpace(props.closeModalUploadTicket) })] }), _jsx(Modal.Body, { children: _jsx(UploadingArtFiles, { pageName: "ticket_history/".concat(artId), closeModal: props.closeModalUploadTicket, handleFormSubmit: handleFormSubmit, isCorrection: isCorrection, handleCorrectionClick: handleCorrectionClick, isContesting: isContesting, handleContestClick: handleContestClick, textAreaValue: textAreaValue, handleChange: handleChange, artId: artId, file: file, setFile: setFile, linkText: linkText, setLinkText: setLinkText }) })] })));
}
export default ModalUploadTicket;
